<ol class="rail" [attr.aria-label]="ariaLabel()">
  @for (stage of stages(); track $index) {
    <li [attr.aria-current]="stage.status === 'current' ? 'step' : null" class="rail__item rail__item--{{ stage.status }}">
      <span class="rail__marker" aria-hidden="true">
        @if (stage.status === 'done') {
          <i class="pi pi-check"></i>
        } @else if (stage.status === 'skipped') {
          <i class="pi pi-minus"></i>
        }
      </span>
      <span class="rail__label">{{ stage.label }}</span>
      <span class="rail__detail">{{ stage.detail }}</span>
      <span class="visually-hidden">Status: {{ stage.status }}</span>
    </li>
  }
</ol>
